/* eslint no-unused-vars: 0 */

import { Canvas, TEvent } from 'fabric';
import { FabricCanvasTool } from '../index';
import { SketchProperties, Tool } from '../../../../types';

// eslint-disable-next-line import/prefer-default-export
export class Pan extends FabricCanvasTool {
    private prevX: number;

    private prevY: number;

    private isDown: boolean;

    type(): Tool {
        return Tool.PAN;
    }

    constructor(canvas: Canvas) {
        super(canvas);
        this.prevX = 0;
        this.prevY = 0;
        this.isDown = false;
    }

    configureCanvas(props: SketchProperties) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        this.canvas.forEachObject(o => { o.selectable = false; o.evented = false; });
        // Change the cursor to the move grabber
        this.canvas.defaultCursor = 'move';
    }

    doMouseDown(o: TEvent) {
        this.isDown = true;
        const pointer = this.canvas.getPointer(o.e);
        this.prevX = pointer.x;
        this.prevY = pointer.y;
    }

    doMouseMove(o: TEvent) {
        if (!this.isDown) return;
        const pointer = this.canvas.getPointer(o.e);
        const diffX = this.prevX - pointer.x;
        const diffY = this.prevY - pointer.y;
        this.canvas.wrapperEl.parentElement!.scrollBy(diffX, diffY);
        this.prevX = pointer.x;
        this.prevY = pointer.y;
    }

    doMouseUp(o: TEvent) {
        this.isDown = false;
    }
}
